// (c) Copyright 2024-2025 Hewlett Packard Enterprise Development LP

import { useNavigate } from "react-router-dom"
import { useEffect, useRef } from "react"
import authService from "./auth-service"
import { ACCOUNT_KEY, REDIRECT_URI_KEY } from "./constants"
import { flagManager } from "../flag-manager"
import { getOIDCConfig } from "./oidc-config"

export function AuthCallback() {
  const navigate = useNavigate()
  const runCallback = useRef(true)

  useEffect(() => {
    if (!runCallback.current) {
      return
    }
    runCallback.current = false

    const useWorkspaceIssuer = flagManager.getFlag("dscc-workspace-issuer")
    let account
    try {
      account = JSON.parse(localStorage.getItem(ACCOUNT_KEY))
    } catch (e) {
      console.error(e)
    }
    const workspaceId = account?.workspaceId ?? null

    authService
      .configure(getOIDCConfig({ workspaceId, useWorkspaceIssuer }))
      .signinRedirectCallback()
      .then(() => {
        const redirectTo =
          window.sessionStorage.getItem(REDIRECT_URI_KEY) || "/"
        window.sessionStorage.removeItem(REDIRECT_URI_KEY)

        navigate(redirectTo, { replace: true })
      })
      .catch((e) => {
        console.error(e)
      })
  }, [navigate])

  return (
    <div>
      <p>Authenticating...</p>
    </div>
  )
}
